import { useEffect, useCallback, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './notification.scss';
import * as util from '../../../utils/commonUtil';
import { updateDoctorRecall, fetchDoctorById } from '../../../api/etokenService';

const Notification = ({ inProgressPatient, doctorId }) => {
    const getDoctorData = useCallback(async () => {
        try {
            const data = await fetchDoctorById(doctorId);
            const doctor = data.doctors[0];
            if (doctor?.recall == "Y" && inProgressPatient?.status === "In Progress") {
                await updateDoctorRecall(doctorId, "N");
                const message = `${inProgressPatient?.patient_name} Token Number: ${inProgressPatient?.token_no}, डॉक्टर ने आपको बुलाया है, कृपया डॉक्टर के पास परामर्श के लिए जाएं।`;
                util.speakHindi(message);
            }
        } catch (error) {
            console.error("Error fetching doctor data in Notification:", error);
        } 
    }, [doctorId, inProgressPatient?.status, inProgressPatient?.patient_name, inProgressPatient?.token_no]);

    useEffect(() => {
        getDoctorData();
    });

    if (!inProgressPatient) return null;
    return (
        <div className="notification-toast">
            <div className="notification-bell-wrapper">
                <i className="bi bi-bell-fill notification-bell"></i>
            </div>
            <div className="notification-title">{inProgressPatient.patient_name} # {inProgressPatient.token_no}</div>
            <div className="notification-desc"></div>
        </div>
    );
};

export default Notification;
